import { api } from '../api';

export type SearchMatchedBy = 'ROOM' | 'PATIENT_CODE' | 'NAME' | 'BIRTH';

export interface SearchResultUser {
  name: string | null;
  patientCode: string | null;
  birthDate: string | null;
  age: number | null;
}

export interface SearchResultRoom {
  roomNumber: string;
  floor: number;
}

export interface SearchResultBgtSummary {
  date: string;
  hasData: boolean;
  avgScore: number | null;
  source: 'cache' | 'live' | 'empty';
}

export interface SearchResultItem {
  residentId: string;
  status: 'ADMITTED' | 'DISCHARGED';
  type: 'RESIDENT' | 'OUTPATIENT_A' | 'OUTPATIENT_B';
  user: SearchResultUser | null;
  room: SearchResultRoom | null;
  bgtSummary: SearchResultBgtSummary | null;
  matchedBy: SearchMatchedBy;
}

export interface SearchResults {
  query: string;
  items: SearchResultItem[];
}

export async function searchResidents(q: string, limit = 10): Promise<SearchResults> {
  const res = await api.get<SearchResults>('/search', { params: { q, limit } });
  return res.data;
}

export const MATCHED_LABEL: Record<SearchMatchedBy, string> = {
  ROOM: '호실',
  PATIENT_CODE: '환자번호',
  NAME: '이름',
  BIRTH: '생년월일',
};
